export default () => ({
  startPoint1: null,
  startPoint2: null,
  startPoint3: null,
  endPoint: null,
  size: null,
  textDelay: null, // Text change delay
  parallaxSpeed: 4, // Transition amount
  headerOffset: null,

  viewPromotion(heading) {
    Tracking.viewPromotion("Hero", heading);
  },

  selectPromotion(heading) {
    Tracking.selectPromotion("Hero", heading);
  },

  initHero(size) {
    //Initialize variables

    this.headerOffset =
      document
        .getElementById("shopify-section-usp-bar")
        ?.getBoundingClientRect().height +
      document.getElementById("logoWrapper")?.getBoundingClientRect().height;

    this.imageHeight = window.innerHeight * 1.2; //120vh

    if (window.innerWidth < 1024) {
      this.imageHeight = window.innerHeight; //100vh
    }
    //Set heights via window.innerHeight since vh is not very good with mobile devices
    this.$refs.imageWrapper1 &&
      (this.$refs.imageWrapper1.style.height = `${this.imageHeight}px`);
    this.$refs.imageWrapper2 &&
      (this.$refs.imageWrapper2.style.height = `${this.imageHeight}px`);
    this.$refs.imageWrapper3 &&
      (this.$refs.imageWrapper3.style.height = `${this.imageHeight}px`);

    this.size = size;
    this.startPoint1 = this.headerOffset;
    this.startPoint2 = this.headerOffset + this.imageHeight;
    this.startPoint3 = this.headerOffset + this.imageHeight * 2;
    this.endPoint =
      this.headerOffset + this.$refs.wrapper.getBoundingClientRect().height;

    // set textdelay for switching heading. Lower on mobile since iOS gives a lower vh initially
    this.textDelay =
      window.innerWidth < 1024 ? this.imageHeight / 5 : this.imageHeight / 2.5;

    // Offset images to prepare for transition
    this.$refs.image1 &&
      (this.$refs.image1.style.marginTop = `${
        -this.headerOffset / this.parallaxSpeed
      }px`);

    this.$refs.image2 &&
      (this.$refs.image2.style.marginTop = `${
        -this.imageHeight / this.parallaxSpeed
      }px`);

    this.$refs.image3 &&
      (this.$refs.image3.style.marginTop = `${
        -this.imageHeight / this.parallaxSpeed
      }px`);

    this.initTextArea();

    //Safari flicker fix
    this.$refs.content &&
      (this.$refs.content.style.transform = "translate3d(0, 0, 0)");

    window.addEventListener("scroll", () =>
      window.requestAnimationFrame(this.onScroll.bind(this))
    );
  },

  initTextArea() {
    //Calculate heading heights
    var firstHeight =
      (this.$refs.heroHeading1 &&
        this.$refs.heroHeading1.getBoundingClientRect().height) ||
      0;
    var secondHeight =
      (this.$refs.heroHeading2 &&
        this.$refs.heroHeading2.getBoundingClientRect().height) ||
      0;
    var thirdHeight =
      (this.$refs.heroHeading3 &&
        this.$refs.heroHeading3.getBoundingClientRect().height) ||
      0;

    const headingHeight = `${Math.max(
      firstHeight,
      secondHeight,
      thirdHeight
    )}px`;

    this.$refs.heroHeading1 &&
      (this.$refs.heroHeading1.style.height = headingHeight);
    this.$refs.heroHeading2 &&
      (this.$refs.heroHeading2.style.height = headingHeight);
    this.$refs.heroHeading3 &&
      (this.$refs.heroHeading3.style.height = headingHeight);
    this.$refs.heroHeadingWrapper &&
      (this.$refs.heroHeadingWrapper.style.maxHeight = headingHeight);

    //Calculate paragraph heights
    var firstParagraphHeight =
      (this.$refs.heroParagraph1 &&
        this.$refs.heroParagraph1.getBoundingClientRect().height) ||
      0;
    var secondParagraphHeight =
      (this.$refs.heroParagraph2 &&
        this.$refs.heroParagraph2.getBoundingClientRect().height) ||
      0;
    var thirdParagraphHeight =
      (this.$refs.heroParagraph3 &&
        this.$refs.heroParagraph3.getBoundingClientRect().height) ||
      0;

    const paragraphHeight = Math.max(
      firstParagraphHeight,
      secondParagraphHeight,
      thirdParagraphHeight
    );

    this.$refs.heroParagraph1 &&
      (this.$refs.heroParagraph1.style.height = `${paragraphHeight}px`);
    this.$refs.heroParagraph2 &&
      (this.$refs.heroParagraph2.style.height = `${paragraphHeight}px`);
    this.$refs.heroParagraph3 &&
      (this.$refs.heroParagraph3.style.height = `${paragraphHeight}px`);

    this.$refs.heroParagraphWrapper &&
      (this.$refs.heroParagraphWrapper.style.maxHeight = `${paragraphHeight}px`);

    //Margin top for paragraph

    if (paragraphHeight > 0) {
      this.$refs.heroParagraphWrapper.style.marginTop = "24px";
    }

    //Done
    this.$refs.heroTextArea &&
      (this.$refs.heroTextArea.style.visibility = "visible");
  },

  onScroll() {
    var scrollNumber = window.pageYOffset;

    if (scrollNumber < this.endPoint) {
      // Translate First Image
      if (
        this.$refs.image1 &&
        this.size >= 1 &&
        scrollNumber < this.startPoint2
      ) {
        var imgPos1 = Math.max(0, scrollNumber / this.parallaxSpeed);
        this.$refs.image1.style.transform = `translate3d(0px, ${imgPos1}px, 0px)`;
      }
      // Translate Second Image
      if (
        this.$refs.image2 &&
        this.size >= 2 &&
        scrollNumber >= this.startPoint1 &&
        scrollNumber < this.startPoint3
      ) {
        var imgPos2 = Math.max(
          0,
          (scrollNumber - this.startPoint1) / this.parallaxSpeed
        );
        this.$refs.image2.style.transform = `translate3d(0px, ${imgPos2}px, 0px)`;
      }
      // Translate Third Image
      if (
        this.$refs.image3 &&
        this.size > 2 &&
        scrollNumber >= this.startPoint2
      ) {
        var imgPos3 = Math.max(
          0,
          (scrollNumber - this.startPoint2) / this.parallaxSpeed
        );
        this.$refs.image3.style.transform = `translate3d(0px, ${imgPos3}px, 0px)`;
      }

      this.textTransitions(scrollNumber);
    }
  },

  textTransitions(scrollNumber) {
    // Text positioning
    var textTransition = 100 / this.size;
    var transitionTarget;

    if (scrollNumber < this.startPoint1 + this.textDelay) {
      transitionTarget = 0;
    }
    if (scrollNumber > this.startPoint1 + this.textDelay && this.size > 1) {
      transitionTarget = textTransition;
    }
    if (scrollNumber > this.startPoint2 + this.textDelay && this.size > 2) {
      transitionTarget = textTransition * 2;
    }

    // Translate text when reaching a new image
    this.$refs.heroHeadingTransition &&
      this.size > 1 &&
      (this.$refs.heroHeadingTransition.style.transform = `translate3d(0, ${transitionTarget}%, 0)`);

    this.$refs.heroParagraphTransition &&
      this.size > 1 &&
      (this.$refs.heroParagraphTransition.style.transform = `translate3d(0, ${transitionTarget}%, 0)`);

    this.$refs.heroButtonTransition &&
      this.size > 1 &&
      (this.$refs.heroButtonTransition.style.transform = `translate3d(0, ${transitionTarget}%, 0)`);
  },
});
